export default __webpack_public_path__ + "static/media/2.2a3128ca.png";